<template>
  <v-navigation-drawer
    v-model="navigationVisibilityStore.clientAppsMenuVisibility"
    color="primary"
    class="position-fixed"
    :width="60"
    permanent
  >
    <router-view name="pass-through-menu-client-apps" />
  </v-navigation-drawer>
</template>

<script setup lang="ts">
import { useNavigationVisibilityStore } from '@/store/NavigationVisibilityStore'
import { useResizeObserverNavigationVisibility } from '@/util/composables/useResizeObserverNavigationVisibility'
useResizeObserverNavigationVisibility()
const navigationVisibilityStore = useNavigationVisibilityStore()
</script>

<style lang="scss" scoped></style>
